// extracted by mini-css-extract-plugin
export var cardBody = "ct_j0";
export var cardContent = "ct_jY";
export var cardFooter = "ct_jZ";
export var container = "ct_cc";
export var gridCardAParent = "ct_j1";
export var imageContainer = "ct_br";